import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2848b90a")

_pushScopeId("data-v-2848b90a")
const _hoisted_1 = {
  key: 0,
  id: "toast__custom",
  class: "fixed inset-0 inset-y-16 toast-container flex items-start justify-end is-show px-4 py-6 pointer-events-none sm:p-6"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "text-white max-w-xs text-base notify-text"
}
const _hoisted_4 = { class: "ml-4 w-5 h-5" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_CloseNotify = _resolveComponent("CloseNotify")

  return (_ctx.notification && _ctx.notification.type)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", {
          class: ["flex items-center py-2 px-4 rounded-lg w-24 notify justify-between", 
        _ctx.packages[_ctx.notification.type] && _ctx.packages[_ctx.notification.type].classes
      ]
        }, [
          (_ctx.notification.errors && _ctx.notification.errors.length)
            ? (_openBlock(), _createBlock("div", _hoisted_2, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.notification.errors, (item, index) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "text-white max-w-xs text-base notify-text",
                    key: index
                  }, _toDisplayString(item.title), 1))
                }), 128))
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_3, _toDisplayString(_ctx.notification.message || _ctx.t('errors.serverError')), 1)),
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_CloseNotify)
          ])
        ], 2)
      ]))
    : _createCommentVNode("", true)
})